import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getEstimate, createOrder } from '../services/api.js';

function Estimate() {
  const [estimate, setEstimate] = useState({ amount: 0, units: 0, breakdown: [] });
  const [delivery, setDelivery] = useState('weekly');
  const navigate = useNavigate();

  useEffect(() => {
    const fetchEstimate = async () => {
      const data = await getEstimate();
      if (data && data.success !== false) {
        console.log('Estimate data:', data);
        setEstimate({ ...data, breakdown: data.breakdown || [] });
      } else {
        alert('Error fetching estimate: ' + (data?.error || 'Unknown error'));
      }
    };
    fetchEstimate();
  }, []);

  const handleOrder = async () => {
    // Get store_id from localStorage
    const store_id = localStorage.getItem('store_id');

    if (!store_id) {
      alert('Store information not found. Please sign up again.');
      navigate('/signup');
      return;
    }

    const result = await createOrder({
      store_id: parseInt(store_id),
      estimate,
      delivery
    });

    if (result.success) {
      // Clear store_id from localStorage after successful order
      localStorage.removeItem('store_id');
      navigate('/confirmation');
    } else {
      alert('Error placing order: ' + result.error);
    }
  };

  return (
    <div className="container mt-5">
      <div className="row justify-content-center">
        <div className="col-lg-6">
          <div className="text-center mb-4">
            <h1 className="display-5 fw-light text-muted">Your Estimate</h1>
            <p className="lead text-muted">Review and customize your order</p>
          </div>
          <div className="card border-0 shadow-sm mb-4">
            <div className="card-body p-4">
              <div className="text-center mb-4">
                <div className="mb-3">
                  <span className="text-muted">Total amount: ${estimate.amount}</span>
                </div>
              </div>
              <div className="mb-4">
                <table className="table table-borderless">
                  <thead>
                    <tr>
                      <th className="text-muted">Product</th>
                      <th className="text-muted text-end">Price per Unit</th>
                      <th className="text-muted text-end">Units</th>
                    </tr>
                  </thead>
                  <tbody>
                    {estimate.breakdown.map(product => (
                      <tr key={product.id}>
                        <td>{product.product_name}</td>
                        <td className="text-end">${parseFloat(product.price).toFixed(2)}</td>
                        <td className="text-end">{product.units}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div className="mb-4">
                <label className="form-label text-muted">Delivery Frequency</label>
                <select value={delivery} onChange={(e) => setDelivery(e.target.value)} className="form-select border-0 bg-light">
                  <option value="weekly">Weekly</option>
                  <option value="bi-weekly">Bi-weekly</option>
                  <option value="monthly">Monthly</option>
                </select>
              </div>
              <div className="text-center">
                <button onClick={handleOrder} className="btn btn-outline-primary btn-lg px-5 py-3 rounded-pill">
                  Place Order
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Estimate;
